module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedMedium.0ff00c8.woff";